module.exports = __webpack_public_path__ + "static/media/omnix.65df0717.jpg";